import type { RowSelectionState } from "@tanstack/react-table";
import type { Invoice } from "@common/types/invoice";

/** The loaded invoices checked in `rowSelection`. */
export const getSelectedInvoices = (
    invoices: Invoice[] | undefined,
    rowSelection: RowSelectionState | undefined,
): Invoice[] =>
    rowSelection && invoices
        ? invoices.filter((invoice) => rowSelection[invoice.id])
        : [];
